<template>
  <div class="file-upload">
    <b-modal :active.sync="modal.active" has-modal-card>
      <form @submit.prevent="upload">
        <div class="order-operation-notes-modal modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title has-text-weight-bold">Upload File</p>
          </header>
          <section class="modal-card-body">
            <b-field label="File"></b-field>
            <b-field class="file">
              <b-upload v-model="form.file" :accept="accept">
                <a class="button is-dark">
                  <span>Choose file</span>
                </a>
              </b-upload>
              <span class="file-name">{{ form.file ? form.file.name : "No file chosen" }}</span>
            </b-field>
            <b-field label="Type" v-if="types">
              <b-select v-model="form.type">
                <option v-for="type in types" :value="type.value" :key="type.value">{{ type.label }}</option>
              </b-select>
            </b-field>
              <tags-input :label="'Tags'" :allowNew="true" @selectedTags="selectedTags" :values="form.tags" />
            <b-field label="Description">
              <b-input type="textarea" v-model="form.description"></b-input>
            </b-field>

            <!--

            <b-field label="Select who you want to see this document?">

            </b-field>

              <div class="field">
                  <b-checkbox v-model="viewers.colleagues">Colleagues</b-checkbox>
              </div>

              <div class="field">
                  <b-checkbox v-model="viewers.customers">Customers</b-checkbox>
              </div>

              <div class="field">
                  <b-checkbox v-model="viewers.vendors">Vendors</b-checkbox>
              </div>

          -->

          </section>

          <footer class="modal-card-foot">
            <b-button :disabled="loading" @click="close">Cancel</b-button>
            <b-button type="is-info" native-type="submit" :loading="loading" :disabled="!validate">Upload</b-button>
          </footer>
        </div>
      </form>
    </b-modal>
    <slot name="button" :open="open">
      <b-button type="is-dark" @click="open">UPLOAD</b-button>
    </slot>
  </div>
</template>

<script>
import { FileService } from "@/services/file.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import debounce from "lodash/debounce";
import TagsInput from "@/components/partials/TagsInput";

export default {
  fileService: FileService,
  props: {
    model: {
      type: String,
      required: true
    },
    modelId: {
      type: String,
      required: true
    },
    accept: {
      type: String
    },
    acceptedMimeTypes: {
      type: Array,
      default: () => []
    }
  },
  components:{
    TagsInput
  },
  data: () => ({
    modal: {
      active: false
    },
    form: {
      file: null,
      type: "",
      description: "",
      tags: null
    },
    loading: false,
    viewers: {colleagues: false, customers: false, vendors: false}
  }),
  computed: {
    types() {
      return [
        {
          value: "Report",
          label: "Report"
        },
        {
          value: "Photo",
          label: "Photograph"
        },
        {
          value: "Checklist",
          label: "Checklist"
        },
        {
          value: "Site Notes",
          label: "Site Notes"
        }
      ];
    },

    validate() {

      return this.form.file ? true: false;

    }

  },
  created() {
    this.setForm();
  },
  methods: {
    setForm() {
      this.form = {
        file: null,
        type: this.types ? this.types[0].value : "",
        description: "",
        tags: null
      };
    },
    selectedTags(tags){
      this.form.tags = tags
    },
    open() {
      this.modal.active = true;
    },
    close() {
      this.setForm();
      this.modal.active = false;
    },
    async upload() {
      if (this.form.file && this.acceptedMimeTypes.length) {
        const mimeType = this.form.file.type;

        if (!this.acceptedMimeTypes.includes(mimeType)) {
          this.$buefy.toast.open({
            message: "Invalid file type.",
            type: "is-danger",
            position: "is-top-right"
          });
          return;
        }
      }

      const data = new FormData();

      data.append("model", this.model);

      data.append("modelId", this.modelId);

      let viewers = [];

      Object.entries(this.viewers).forEach(viewer => {

        viewers.push(viewer);

      });

      data.append("viewers", viewers);

      if (this.form.file) {
        data.append("file", this.form.file);
      }

      if (this.form.type) {
        data.append("subtype", this.form.type);
      }

      if (this.form.description) {
        data.append("description", this.form.description);
      }

      if (this.form.tags) {
        this.form.tags.forEach(tag => {
          data.append("tags[]", tag);
        });
      }

      this.loading = true;

      try {
        const file = await this.$options.fileService
          .uploadFile(data)
          .then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "File has been uploaded.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("uploaded", file);
        this.close();
      } catch (rrr) {}

      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Documents/File/FileUpload.vue